<template>

    <form ref="parametro-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <label for="chave">Chave</label>
                        <input type="text" class="form-control" name="chave" placeholder="Chave" v-model="model.chave" required disabled />
                    </div>
					<div class="form-group col-md-12">
                        <label for="descricao">Descrição</label>
                        <input type="text" class="form-control" name="descricao" placeholder="Descricao" v-model="model.descricao"  disabled/>
                    </div>
					<div class="form-group col-md-12">
                        <label for="label">Label</label>
                        <input type="text" class="form-control" name="label" placeholder="Label" v-model="model.label"  disabled/>
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorPadrao">Valor Padrão</label>
                        <input type="text" class="form-control" name="valorPadrao" placeholder="ValorPadrao" v-model="model.valorPadrao" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="ressalva">Ressalva</label>
                        <input type="text" class="form-control" name="ressalva" placeholder="Ressalva" v-model="model.ressalva"  />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="sistema" class="custom-control-input" v-model="model.sistema" disabled>
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Sistema?</span>
                        </label>
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "parametro-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "parametro-form-edit",
            
            resources: {
                edit: 'parametro',
            },

        }),
		
        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false)return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ parametroId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>